<template>
	<div class="fixed inset-0 z-30 flex items-center justify-center p-4 bg-black/40" @click="emit('close')">
		<div class="relative w-full max-w-sm p-5 overflow-hidden bg-white rounded-lg" @click.stop>
			<Calendar
				ref="calendarRef"
				v-model="selectedDates"
				:workspace-id="workspaceId"
				:language="locale"
				:highlight-swimwear-days="highlightSwimwearDays"
				@days-selected="hasChosenDate = true"
			>
				<template #footer>
					<button
						v-if="hasChosenDate"
						type="button"
						class="flex items-center gap-1 text-neutral-700 hover:text-neutral-950 transition-colors"
						@click="emit('clear')"
					>
						<TrashIcon class="h-3.5" />
						{{ t('clear_date') }}
					</button>
				</template>
			</Calendar>

			<ToggleField
				v-if="calendarRef?.showSwimwearDayInfo || highlightSwimwearDays"
				v-model="highlightSwimwearDays"
				slot-position="before"
				class="mt-4 text-sm"
			>
				{{ t('filter_swimwear_days') }}
			</ToggleField>

			<div class="flex gap-4 max-md:flex-col mt-8">
				<button type="button" class="btn-secondary max-md:w-full max-md:order-last" @click="emit('close')">
					{{ t("cancel") }}
				</button>
				<button type="button" class="btn-primary max-md:w-full md:flex-1 max-md:order-first" @click="onSelect()">
					{{ t("ok") }}
				</button>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import { ref } from 'vue';
import TrashIcon from '@thermenresorts/icons/svg/trash.svg';
import Calendar from './Calendar.vue';
import ToggleField from './ToggleField.vue';

export type Props = {
  workspaceId?: number
  modelValue: string[]
}

const props = defineProps<Props>();

const emit = defineEmits([
  'clear',
  'close',
  'select',
  'update:modelValue'
]);

const { t, locale } = useI18n();

const calendarRef = ref<InstanceType<typeof Calendar>>();
const selectedDates = ref(props.modelValue);
const hasChosenDate = ref(props.modelValue.length > 0);
const highlightSwimwearDays = ref(false);

const onSelect = () => {
  emit('update:modelValue', selectedDates.value);
  emit('close');
  emit('select', selectedDates.value);
}
</script>
